module.exports = __webpack_public_path__ + "static/img/iPhone_show.110ffa69.png";